import { CloseRounded, EditOutlined } from "@mui/icons-material";
import { Box, Checkbox, IconButton, Tooltip } from "@mui/material";
import { green, grey, red } from "@mui/material/colors";
import { AgGridReact } from "ag-grid-react";
import { get, isEmpty, isNil } from "lodash";
import { useCallback, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDrilldownBase } from "../../../../pipelines/PipelineContext";
import FlxGrid from "../../../../_src_shared/components/layout/FlxGrid";
import PrimaryContentCard from "../../../../_src_shared/components/layout/PrimaryContentCard";
import { columnTypesBoolean } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesBoolean.js";
import { columnTypesPercent } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesPercent.js";
import { formatAddressObjectFullAddress } from "../../../../_src_shared/utils/functions/formatAddressObjectFullAddress.js";
import AgGridTableWrapper from "../../../../components/agGrid/AgGridTableWrapper.js";
import JsonPreview from "../../../../components/common/JsonPreview";
import LoanFilesDisplayTable from "../../../../components/common/Loan/tables/LoanFilesDisplayTable";
import UpdateLoanRootDataFieldsModal from "../../../../components/common/Loan/UpdateLoanRootDataFieldsModal";
import OverviewItem from "../../../../components/data/OverviewItem";
import Flx from "../../../../components/layout/Flx";
import TabContent from "../../../../components/navigation/TabContent.js";
import ToggleTabSwitcher from "../../../../components/navigation/ToggleTabSwitcher";
import Txt from "../../../../components/typography/Txt";
import InsetCard from "../../../../components/ui/InsetCard";
import { selectOptionsEntityType } from "../../../../constants/selectOptions/selectOptionsEntityType";
import { selectOptionsUsaStates } from "../../../../constants/selectOptions/selectOptionsUsaStates";
import { camelCaseToSentence } from "../../../../utils/strings/camelCaseToSentence";
const TABS = {
  OVERVIEW: "Overview",
  DETAILS: "Details",
  // ADDRESS: "Address",
  MEMBERS_MANAGERS: "Members/Managers",
  FILES: "Files",
  RAW_JSON: "Raw JSON",
};
const LoanEntityDetailsCard = ({ entity }) => {
  const navigate = useNavigate();
  const drilldownBase = useDrilldownBase();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const title = useMemo(() => entity?.entityName, [entity?.entityName]);
  const [tab, setTab] = useState(TABS.OVERVIEW);

  const onClose = useCallback(() => {
    navigate(`${drilldownBase}/${loanDrilldown?._id}/borrowers`);
  }, [navigate, drilldownBase, loanDrilldown?._id]);

  const subTitle = useMemo(() => {
    return formatAddressObjectFullAddress(entity?.entityAddress);
  }, [entity?.entityAddress]);
  if (isNil(entity)) {
    return null;
  }
  return (
    <PrimaryContentCard
      maxWidth="lg"
      title={title}
      subTitle={subTitle}
      headerSx={{ mb: 1 }}
      endContent={
        <Flx ac>
          {/* <AssignBorrowerFilesButton entity={entity} /> */}
          {/* <AssignLoanFilesButton borrower={entity} /> */}
          <IconButton onClick={onClose}>
            <CloseRounded className="thin" />
          </IconButton>
        </Flx>
      }
      // subTitle={headerSubtitle}
      // loading={isNil(loanTerms)}
    >
      <ToggleTabSwitcher
        value={tab}
        onChange={setTab}
        variant="underline"
        tabs={Object.values(TABS)}
      />

      <Flx column g={2}>
        <EntityDetailsTab tab={tab} entity={entity} />
        <EntityMembersTab tab={tab} entity={entity} />
        <EntityFilesTab tab={tab} entity={entity} />
        <EntityJsonTab tab={tab} entity={entity} />
      </Flx>
    </PrimaryContentCard>
  );
};

/**
 * ====== TABS ======
 */

// MEMBERS TAB
const EntityDetailsTab = ({ tab, entity }) => {
  return (
    <TabContent
      activeTab={tab}
      tabKey={TABS.DETAILS}
      forceReturnValue={TABS.OVERVIEW}
      forceReturnContent={
        <InsetCard grey>
          <Flx column grow={1} gap={4}>
            <EntityDetailsSection entity={entity} />
            <CustomSection title="Entity Address">
              <Txt bold fontSize={12}>
                {formatAddressObjectFullAddress(entity?.entityAddress)}
              </Txt>
            </CustomSection>
            <LabeledSection label="Entity Members/Managers">
              <EntityMembersTab entity={entity} tab={TABS.MEMBERS_MANAGERS} />
            </LabeledSection>
          </Flx>
        </InsetCard>
      }
    >
      <InsetCard grey>
        <Flx column grow={1} gap={4}>
          <EntityDetailsSection entity={entity} />
          <EntityAddressSection entity={entity} />
        </Flx>
      </InsetCard>
    </TabContent>
  );
  // return (
  //   <TabPanel
  //     value={tab}
  //     forceDisplay={TABS.OVERVIEW}
  //     tabValue={TABS.DETAILS}
  //     forceDisplayReturn={
  //       <InsetCard grey>
  //         <Flx column grow={1} gap={4}>
  //           <EntityDetailsSection entity={entity} />
  //           <CustomSection title="Entity Address">
  //             <Txt bold fontSize={12}>
  //               {formatAddressObjectFullAddress(entity?.entityAddress)}
  //             </Txt>
  //           </CustomSection>
  //           <LabeledSection label="Entity Members/Managers">
  //             <EntityMembersTab entity={entity} tab={TABS.MEMBERS_MANAGERS} />
  //           </LabeledSection>
  //         </Flx>
  //       </InsetCard>
  //     }
  //   >
  //     <InsetCard grey>
  //       <Flx column grow={1} gap={4}>
  //         <EntityDetailsSection entity={entity} />
  //         <EntityAddressSection entity={entity} />
  //       </Flx>
  //     </InsetCard>
  //   </TabPanel>
  // );
};

// MEMBERS TAB
const EntityMembersTab = ({ tab, entity }) => {
  const entityMembers = useMemo(() => {
    return entity?.entityMembers || [];
  }, [entity?.entityMembers]);

  const content = (
    <InsetCard sx={{ p: 0, overflow: "hidden" }}>
      <EntityMembersTable entityMembers={entityMembers} />
    </InsetCard>
  );

  if (tab !== TABS.MEMBERS_MANAGERS) {
    return null;
  }
  return (
    <TabContent
      activeTab={tab}
      tabKey={TABS.MEMBERS_MANAGERS}
      forceReturnValue={TABS.OVERVIEW}
      forceReturnContent={
        null
        // <InsetCard grey>
        //   <LabeledSection label="Members/Managers" bodyPadding={0}>
        //     {content}
        //   </LabeledSection>
        // </InsetCard>
      }
    >
      {content}

      {/* <FlxGrid
          // grow={1}
          gridTemplateColumns={"620px 1fr"}
          // width="400px"
          gap={4}
        >
          <CustomSection title="Members/Managers" bodyPadding={0}>
            <EntityMembersTable entityMembers={entityMembers} />
          </CustomSection>
          <CustomSection title="Members/Managers" bodyPadding={0}>
            <EntityMembersTable entityMembers={entityMembers} />
          </CustomSection>
        </FlxGrid> */}
    </TabContent>
  );
};

// FILES TAB
const EntityFilesTab = ({ tab, entity }) => {
  return (
    <TabContent
      activeTab={tab}
      forceReturnValue={TABS.OVERVIEW}
      tabKey={TABS.FILES}
    >
      {/* <TitledSection sx={{ mt: 3 }} label="Entity Files"> */}
      <InsetCard sx={{ p: 0, overflow: "hidden" }}>
        <EntityFilesTable entity={entity} />
      </InsetCard>
      {/* </TitledSection> */}
    </TabContent>
  );
};

// RAW JSON TAB
const EntityJsonTab = ({ tab, entity }) => {
  return (
    <TabContent activeTab={tab} tabKey={TABS.RAW_JSON}>
      <JsonPreview values={entity} defaultCollapse={3} />
    </TabContent>
  );
};

/**
 * ====== TAB CONTENT COMPONENTS ======
 */

const EntityDetailsSection = ({ entity, tabName, activeTab }) => {
  const fields = useMemo(
    () => [
      {
        name: "entityName",
        label: "Entity Name",
      },

      {
        name: "entityStateOfOrganization",
        label: "Entity State Of Organization",
        type: "selectAutocomplete",
        options: selectOptionsUsaStates,
      },
      {
        name: "entityType",
        label: "Entity Type",
        type: "selectToggle",
        options: selectOptionsEntityType,
      },
      {
        name: "entityOrganizationDate",
        label: "Entity Organization Date",
        type: "date",
      },
      {
        name: "entityEINNumber",
        label: "Entity EIN Number",
      },

      {
        name: "entityGoodstandingDate",
        label: "Entity Goodstanding Date",
        type: "date",
      },
      {
        name: "entityNotes",
        label: "Entity Notes",
        type: "stringMultiline",
      },
    ],
    [],
  );

  return (
    <EditableEntitySection
      title={"Entity Details"}
      // title="Borrower Details"
      // title="Identity & Personal Information"
      fields={fields}
      tabName={tabName}
      activeTab={activeTab}
      entity={entity}
    />
  );
};

const EntityAddressSection = ({ entity, tabName, activeTab }) => {
  const fields = useMemo(() => {
    return [
      {
        name: "entityAddress.streetNumber",
        label: "Street Number",
      },
      {
        name: "entityAddress.streetName",
        label: "Street Name",
      },
      {
        name: "entityAddress.unit",
        label: "Unit/Suite/Apt",
      },
      {
        name: "entityAddress.city",
        label: "City",
      },
      {
        name: "entityAddress.state",
        label: "State",
      },
      {
        name: "entityAddress.zip",
        label: "Zip Code",
      },
      {
        name: "entityAddress.county",
        label: "County",
      },
      {
        name: "entityAddress.country",
        label: "Country",
      },
    ];
  }, []);

  return (
    <EditableEntitySection
      title="Entity Address"
      fields={fields}
      tabName={tabName}
      activeTab={activeTab}
      entity={entity}
    />
  );
};

const EntityFilesTable = ({ entity, tabName, activeTab }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const entityDocs = useMemo(() => {
    return loanDrilldown?.loanDocuments?.filter(
      (d) => d?.docGroup === "Entity Docs" && !d?.isHidden,
    );
  }, [loanDrilldown?.loanDocuments]);

  return (
    <LoanFilesDisplayTable
      headerHeight={null}
      rowData={entityDocs}
      groupMode={"docType"}
      view="standard"
      showDocTypeColumn
    />
  );
};

const EntityMembersTable = ({
  entityMembers = [],
  // Useful for nested rendering to avoid overly loud totals if you prefer
  showPinnedTotals = true,
}) => {
  const ref = useRef();

  // Normalize percent to 0-1 for your percent column type.
  // - If value > 1, assume 0-100 and convert to 0-1.
  const normalizeOwnership = (value) => {
    if (isNil(value)) return 0;
    const num = Number(value);
    if (Number.isNaN(num)) return 0;
    return num > 1 ? num / 100 : num;
  };

  const isEntityRow = (row) => {
    if (!row) return false;
    if (row.memberType === "entity") return true;
    return typeof row.entityName === "string" && !isEmpty(row.entityMembers);
  };

  const rowData = useMemo(() => entityMembers, [entityMembers]);

  const totalOwnershipNormalized = useMemo(() => {
    return (entityMembers || []).reduce((sum, m) => {
      return sum + normalizeOwnership(m?.entityPercentOwnership);
    }, 0);
  }, [entityMembers]);

  // -----------------------------
  // Recursive detail renderer
  // -----------------------------
  const EntityMembersDetailRenderer = (props) => {
    const nestedMembers = props?.data?.entityMembers || [];
    if (isEmpty(nestedMembers)) return null;

    // Recursively render the same table for nested entity members.
    // You can choose whether nested tables should show totals.
    return (
      <Box sx={{ p: 2, pl: 5, background: grey[100] }}>
        <Box sx={{ overflow: "hidden", borderRadius: 2 }}>
          <EntityMembersTable
            entityMembers={nestedMembers}
            showPinnedTotals={false}
          />
        </Box>
      </Box>
    );
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Member",
        colId: "memberName",
        flex: 1,
        minWidth: 260,

        // This adds the expand/collapse control for master/detail
        cellRenderer: "agGroupCellRenderer",
        cellRendererParams: {
          suppressCount: true,
        },

        valueGetter: (params) => {
          if (params.node.rowPinned === "bottom") return "Total Ownership";

          const data = params.data || {};
          if (isEntityRow(data)) {
            const name = (data.entityName || "").trim();
            return name ? `${name} (Entity)` : "—";
          }

          const fullName = data.fullName;
          if (typeof fullName === "string" && fullName.trim())
            return fullName.trim();

          const first = data.firstName || "";
          const last = data.lastName || "";
          const combined = `${first} ${last}`.trim();
          return combined || "—";
        },

        cellStyle: (params) =>
          params.node.rowPinned === "bottom" ? { fontWeight: "bold" } : {},
      },
      {
        headerName: "Title",
        field: "title",
        width: 150,
        valueGetter: (params) => {
          if (params.node.rowPinned === "bottom") return "";
          return params.data?.title || "—";
        },
      },
      {
        headerName: "Is Guarantor",
        field: "isGuarantor",
        width: 140,
        cellRenderer: (params) => {
          if (params.node.rowPinned === "bottom") return null;

          // Entity rows generally do not have guarantor; render blank.
          if (isEntityRow(params.data)) return null;

          return <Checkbox checked={!!params.value} disabled />;
        },
        type: "boolean",
      },
      {
        headerName: "Ownership %",
        colId: "ownershipPct",
        type: "percent",
        aggFunc: "sum",
        width: 150,

        valueGetter: (params) => {
          if (params.node.rowPinned === "bottom")
            return totalOwnershipNormalized;
          return normalizeOwnership(params.data?.entityPercentOwnership);
        },

        cellStyle: (params) => {
          if (params.node.rowPinned === "bottom") {
            const isComplete = Math.abs((params.value || 0) - 1) <= 0.005; // within 0.5%
            return {
              backgroundColor: isComplete ? green[100] : red[100],
              fontWeight: "bold",
            };
          }
          return {};
        },
      },
    ],
    [totalOwnershipNormalized, showPinnedTotals],
  );

  const defaultColDef = useMemo(
    () => ({
      filter: true,
      sortable: true,
      resizable: true,
      enableRowGroup: true,
      enablePivot: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      menuTabs: ["filterMenuTab"],
    }),
    [],
  );

  const columnTypes = useMemo(() => {
    return {
      ...columnTypesPercent(),
      ...columnTypesBoolean(),
    };
  }, []);

  return (
    <AgGridTableWrapper simpleTable suppressMinHeightWhenPopulated={rowData}>
      <AgGridReact
        ref={ref}
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        columnTypes={columnTypes}
        // Totals row
        pinnedBottomRowData={showPinnedTotals ? [{}] : []}
        allowDragFromColumnsToolPanel={false}
        domLayout="autoHeight"
        enableCellTextSelection
        suppressAggFuncInHeader
        suppressRowClickSelection={false}
        // Master/detail
        masterDetail
        detailRowAutoHeight
        isRowMaster={(data) =>
          isEntityRow(data) && !isEmpty(data?.entityMembers)
        }
        detailCellRenderer={EntityMembersDetailRenderer}
        // Stable row IDs help AG Grid preserve expansion state
        getRowId={(params) =>
          params.data?._id ? String(params.data._id) : undefined
        }
      />
    </AgGridTableWrapper>
  );
};

const EditableEntitySection = ({
  children,
  title,
  fields,
  entity,
  size = "xs",
  onNavigate,
  // gridWidth = "135px",
  gridWidth = "185px",
  gridGrow = 1,
  gridGap = 3,
  tabName,
  activeTab,
}) => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const drilldownBase = useDrilldownBase();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const onEditClick = useCallback(() => {
    if (fields) {
      setShow(true);
    }

    if (onNavigate) {
      navigate(`${drilldownBase}/${loanDrilldown?._id}/${onNavigate}`);
    }
  }, [fields, onNavigate, loanDrilldown?._id, drilldownBase, navigate]);

  if (tabName !== activeTab && activeTab !== "All") {
    return null;
  }
  return (
    <>
      <UpdateLoanRootDataFieldsModal
        show={show}
        maxWidth={size}
        // formSpy
        entityId={entity?._id}
        onClose={() => setShow(false)}
        fields={fields}
      />

      <CustomSection title={title}>
        <FlxGrid grow={gridGrow} width={gridWidth} gap={gridGap}>
          {(fields || onNavigate) && (
            <Tooltip title="Edit Details">
              <IconButton
                size="small"
                onClick={onEditClick}
                sx={{ position: "absolute", top: 4, right: 4 }}
              >
                <EditOutlined className="thin" sx={{ fontSize: 15 }} />
              </IconButton>
            </Tooltip>
          )}
          {children}
          {fields.map((field) => (
            <DisplayData
              key={field.name}
              name={field.name}
              label={field.label}
              type={field.type}
              data={entity}
            />
          ))}
        </FlxGrid>
      </CustomSection>
    </>
  );
};

/**
 * ===== SUB COMPONENTS ======
 */

const DisplayData = ({ label, value, dataKey, type, name, data }) => {
  // const targetData = useSelector((state) => state?.loanFetchedData?.loanTerms);

  const passedData = useMemo(() => data, [data]);

  const val = useMemo(() => {
    const targetData = isNil(dataKey) ? passedData : passedData?.[dataKey];

    // Preserve prior behavior: if `value` is provided, use it.
    // (Note: this keeps the existing "truthy" behavior; if you want `0` to show,
    // change to `if (!isNil(value)) return value;`.)
    if (value) return value;

    // Supports both flat keys ("foo") and dot-notation ("guc_sold.greater_than_three_years")
    return isNil(name) ? undefined : get(targetData, name);
  }, [name, value, passedData, dataKey]);

  const labelValue = useMemo(() => {
    if (isNil(label)) {
      // If name is dot-notation, labelize the last segment (e.g. "greater_than_three_years")
      const labelSource =
        typeof name === "string" ? name.split(".").pop() : name;
      return camelCaseToSentence(labelSource);
    }
    return label;
  }, [label, name]);

  return (
    <OverviewItem
      label={labelValue}
      type={type}
      value={val}
      sx={{ flexGrow: 1 }}
    />
  );
};

const LabeledSection = ({ label, children, bodyPadding = 2.5, gap = 3 }) => {
  return (
    <Flx column gap={"3px"}>
      {label && (
        <>
          <Txt sx={{ fontWeight: 300, color: grey[800] }} fontSize={12}>
            {label}
          </Txt>
        </>
      )}
      {children}
      {/* <Flx
        column
        sx={{
          position: "relative",
          border: "1px solid #e5e7eb",
          p: bodyPadding,
          overflow: "hidden",
          gap,
          background: "#ffffff",
          borderRadius: 1.5,
        }}
      >
        {children}
      </Flx> */}
    </Flx>
  );
};

const CustomSection = ({
  title,
  children,
  gap = 3,
  activeTab,
  tabName,
  bodyPadding = 2.5,
}) => {
  if (tabName !== activeTab && activeTab !== "All") {
    return null;
  }
  return (
    <Flx column gap={"3px"}>
      {title && (
        <>
          <Txt sx={{ fontWeight: 300, color: grey[800] }} fontSize={12}>
            {title}
          </Txt>
        </>
      )}
      <Flx
        column
        sx={{
          position: "relative",
          border: "1px solid #e5e7eb",
          p: bodyPadding,
          overflow: "hidden",
          gap,
          background: "#ffffff",
          borderRadius: 1.5,
        }}
      >
        {children}
      </Flx>
    </Flx>
  );
};

export default LoanEntityDetailsCard;
